import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

import { ReactComponent as IconStore } from '../../assets/juliafloresrj-icon.svg'
import { verifyAdmin, verifyDeveloper } from '../../utils/verify-admin';
import { api, versao } from '../../config';
import { getHeaders } from '../../actions/localStorage';
import { getAbandonedCartVistoEm, markAbandonedCartsVistos } from '../../utils/abandonedCartMenuBadge';

const items = [
    {rota: "/dashboard", icone: (<i className="fas fa-chart-line"></i>), titulo: "Painel", role: 'owner'},
    {rota: "/", icone: (<i className="fas fa-shopping-bag"></i>), titulo: "Pedidos", role: 'admin'},
    {rota: "/entregas", icone: (<i className="fas fa-shipping-fast"></i>), titulo: "Entregas", role: 'admin'},
    {
        rota: "/carrinhos-abandonados",
        icone: (<i className="fas fa-shopping-cart"></i>),
        titulo: "Carrinhos abandonados",
        role: ['developer', 'owner', 'admin'],
    },
    {rota: "/clientes", icone: (<i className="fas fa-users"></i>), titulo: "Clientes", role: ['admin', 'mkt']},
    {rota: "/categorias", icone: (<i className="fas fa-tags"></i>), titulo: "Categorias", role: 'admin'},
    {rota: "/produtos", icone: (<i className="fas fa-boxes"></i>), titulo: "Produtos", role: 'admin'},
    {rota: "/upsells", icone: (<i className="fas fa-gifts"></i>), titulo: "Upsells", role: 'admin'},
    {rota: "/reports", icone: (<i className="fas fa-file-contract"></i>), titulo: "Relatórios", role: 'admin'},
    {
        rota: "/email-marketing",
        icone: (<i className="fas fa-envelope-open-text"></i>),
        titulo: "E-mail Marketing",
        role: ['owner', 'mkt']
    },
    {
        rota: "/google-applications",
        icone: (<i className="fab fa-google"></i>),
        titulo: "Aplicações Google",
        role: ['owner', 'mkt']
    },
]

const itemsTwo = [
    {rota: "/perfil", icone: (<i className="fas fa-user"></i>), titulo: "Perfil", role: 'admin'},
    {rota: "/usuarios", icone: (<i className="fas fa-user-shield"></i>), titulo: "Usuários", role: 'owner'},
    {rota: "/configuracoes", icone: (<i className="fas fa-cog"></i>), titulo: "Configurações", role: 'owner'},
]

function canAccessAbandonedCarts(admin) {
    if (!admin) return false;
    return (
        verifyDeveloper(admin) ||
        verifyAdmin(admin, 'admin') === true ||
        verifyAdmin(admin, 'owner') === true
    );
}

export default function Menu({ admin, history, handleLogout }) {
	const localAtual = history.location.pathname;
    const [hasNewAbandonedCart, setHasNewAbandonedCart] = useState(false);

    const fetchHasNewAbandonedCart = useCallback(() => {
        if (!admin?.loja || !canAccessAbandonedCarts(admin)) return;

        const desde = getAbandonedCartVistoEm(admin.loja);
        axios
            .get(
                `${api}/${versao}/api/carrinhos-abandonados/admin/novos?loja=${admin.loja}&desde=${encodeURIComponent(desde)}`,
                getHeaders()
            )
            .then((response) => {
                setHasNewAbandonedCart(Boolean(response.data.hasNew));
            })
            .catch(() => {});
    }, [admin]);

    useEffect(() => {
        fetchHasNewAbandonedCart();
        const interval = window.setInterval(fetchHasNewAbandonedCart, 120000);
        return () => window.clearInterval(interval);
    }, [fetchHasNewAbandonedCart]);

    const clearAbandonedCartBadge = useCallback(() => {
        if (!admin?.loja) return;
        markAbandonedCartsVistos(admin.loja);
        setHasNewAbandonedCart(false);
    }, [admin?.loja]);

    return (
        <div className="menu">
            <div className="content">
                <div className="logo">
                    <IconStore/>
                </div>

                <div className="menu-items">
                    {
                        items.map((item, idx) => {
                            if (Array.isArray(item.role)) {
								const allowed = item.role.some((r) =>
									r === 'developer' ? verifyDeveloper(admin) : verifyAdmin(admin, r) === true
								);
								if (!allowed) return null;
							} else {
								if (item.role === 'owner' && !verifyAdmin(admin, 'owner')) return null;
								if (item.role === 'developer' && !verifyDeveloper(admin)) return null;
							}

                            let rotasMkt = [
                                '/clientes',
                                '/email-marketing',
                                '/google-applications'
                            ]
                            if (admin && admin.email === 'agencia@juliafloresrj.com.br' && !rotasMkt.includes(item.rota)) {
                                return null;
                            }
                            if (admin && admin.email === 'agencia@juliafloresrj.com.br') {
                                window.location.replace("/#/clientes");
                            }
                            return (
                                <Link
                                    to={item.rota}
                                    key={idx}
                                    onClick={item.rota === '/carrinhos-abandonados' ? clearAbandonedCartBadge : undefined}
                                    className={`item${localAtual === item.rota ? " active" : ""}`}
                                >
                                    <div className="icon">
                                        {item.icone}
                                        {item.new && <span className="new">Novo</span>}
                                        {item.rota === '/carrinhos-abandonados' && hasNewAbandonedCart ? (
                                            <span
                                                className="menu-badge menu-badge--dot"
                                                title="Novo carrinho abandonado"
                                            />
                                        ) : null}
                                    </div>
                                    <div className="title">
                                        <span className="item-name">{item.titulo}</span>
                                    </div>
                                </Link>
                            )
                        })
                    }
                </div>

                <div className="menu-items">
                    {
                        itemsTwo.map((item, idx) => {
                            if (item.role === "owner" && !verifyAdmin(admin, 'owner')) return null;

                            const activeUsuarios = item.rota === '/usuarios' && localAtual.startsWith('/usuarios');
                            const active = localAtual === item.rota || activeUsuarios;

                            return (
                                <Link to={item.rota} key={idx}
                                      className={`item${active ? " active" : ""}`}>
                                    <div className="icon">
                                        {item.icone}
                                        {item.new && <span className="new">Novo</span>}
                                    </div>
                                    <div className="title">
                                        <span className="item-name">{item.titulo}</span>
                                    </div>
                                </Link>
                            )
                        })
                    }
                    <div onClick={() => handleLogout()} className="button-power"><i className="fas fa-power-off"></i>
                    </div>
                </div>

            </div>
        </div>
    );
}
